module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/axios/index.js
// module id = r81N
// module chunks = 5 6 7 8